export default "__VITE_ASSET__148e6f72__"